import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const menuOptions = {
  element: 'div.signature-card--actions > div > ul > li',
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.OPTIONS.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.OPTIONS.DESCRIPTION'),
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const actionsButton = document.querySelector('.os-icon-more-horizontal');

      if (actionsButton) {
        actionsButton.click();

        GLOBAL_DRIVER_OBJECT.movePrevious();
      }
    },
    onNextClick: () => {
      const editButton = document.querySelector('div.signature-card--actions > div > ul > li > button');

      if (editButton) {
        editButton.click();
      }

      setTimeout(() => {
        GLOBAL_DRIVER_OBJECT.moveNext();
      }, 160);
    }
  }
};
